import { isIngame } from '@/utils/checkIngame';


export default {
  isIngame,
}
